import React from 'react';
import { C, font, serif, btnStyle, btnHoverEnter, btnHoverLeave } from '../shared/constants';
import { useScrollReveal, revealStyle } from '../shared';

const ERAS = [
  { name: 'EXISTENCIA',    mundos: ['00 Raíz', '01 Arrancar', '02 Cimientos', '03 Por qué te compran'], active: [0, 1], badge: "It's Alive!" },
  { name: 'SUPERVIVENCIA', mundos: ['04 Sobrevivir'],                                                   active: [],     badge: 'Still Standing' },
  { name: 'ÉXITO',         mundos: ['05 Ordenar', '06 Eficiencia'],                                     active: [],     badge: 'Boss Mode' },
  { name: 'DESPEGUE',      mundos: ['07 Listo para fondeo', '08 Despegue'],                             active: [],     badge: 'Liftoff', gold: [0] },
  { name: 'MADUREZ',       mundos: ['09 Madurez'],                                                      active: [],     badge: 'Legacy' },
];

const BULLETS = [
  { icon: '✓', title: 'Misiones con evidencia',     body: 'Ya lo tengo o hazla; valida con datos, documentos o testigos.' },
  { icon: '✓', title: 'Milestones medidos con OKR',  body: 'Objetivos y resultados clave en cada mundo.' },
  { icon: '✓', title: 'Insignias y stats',           body: 'Cha-Ching!, Zero Hero, Shark Proof… cada logro suma a tu carta.' },
  { icon: '✓', title: 'Tu negocio es otra persona',  body: 'Aprendes a separar su dinero del tuyo y a medir su salud administrativa.' },
];

export default function SeccionArbol({ isMobile, isTablet, onStart }) {
  const reveal = useScrollReveal();
  const mob = isMobile;

  return (
    <section
      id="arbol"
      ref={reveal.ref}
      style={{
        maxWidth: 1180, margin: '0 auto',
        padding: mob ? '2.5rem 1rem' : '4rem 1.5rem',
        borderTop: `1px solid ${C.border}`,
        ...revealStyle(reveal.inView),
      }}
    >
      <div style={{
        display: 'grid',
        gridTemplateColumns: mob ? '1fr' : '1fr 1fr',
        gap: mob ? 32 : 56, alignItems: 'center',
      }}>
        {/* Left — copy */}
        <div>
          <p style={{
            fontSize: mob ? 11 : 12, letterSpacing: 3, fontWeight: 700,
            textTransform: 'uppercase', color: C.turquesa, margin: '0 0 14px',
          }}>
            01 · Tu árbol de misiones
          </p>

          <h2 style={{
            fontFamily: serif,
            fontSize: mob ? 28 : isTablet ? 36 : 48,
            fontWeight: 400, lineHeight: 1, margin: '0 0 16px', color: '#fff',
          }}>
            Sabe siempre qué sigue{' '}
            <em style={{ color: C.turquesa, fontStyle: 'italic' }}>en tu negocio.</em>
          </h2>

          <p style={{
            fontSize: mob ? 15 : 17, color: 'rgba(255,255,255,0.55)',
            lineHeight: 1.6, margin: '0 0 20px',
          }}>
            Diez mundos, de Existencia a Madurez, basados en cómo crecen las empresas de verdad.
            Llena lo que ya tienes, cumple misiones con evidencia, vence al jefe de cada mundo y
            gana insignias. Nadie te dice cosas básicas: avanzas desde donde estás.
          </p>

          {/* Bullets 2×2 */}
          <div style={{
            display: 'grid', gridTemplateColumns: mob ? '1fr' : '1fr 1fr',
            gap: 12, marginBottom: 22,
          }}>
            {BULLETS.map((b, i) => (
              <div key={i} style={{ display: 'flex', gap: 10, fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>
                <span style={{ color: C.turquesa, fontWeight: 700, flexShrink: 0 }}>{b.icon}</span>
                <div>
                  <strong style={{ display: 'block', color: '#fff', fontSize: 14 }}>{b.title}</strong>
                  {b.body}
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={onStart}
            onMouseEnter={btnHoverEnter} onMouseLeave={btnHoverLeave}
            style={{ ...btnStyle, padding: '13px 28px', fontSize: 15 }}
          >
            Arma tu árbol gratis
          </button>
        </div>

        {/* Right — era tree */}
        <div style={{
          background: 'rgba(255,255,255,0.04)',
          border: `1px solid ${C.border}`,
          borderRadius: 24, padding: mob ? '20px 16px' : '24px 32px',
        }}>
          {ERAS.map((era, ei) => (
            <div key={ei} style={{
              display: 'flex', alignItems: 'center', gap: 14,
              padding: '12px 0', flexWrap: 'wrap',
              borderTop: ei > 0 ? `1px dashed ${C.border}` : 'none',
            }}>
              {/* Era name */}
              <span style={{
                width: mob ? '100%' : 140, fontSize: 11, letterSpacing: 2,
                fontWeight: 700, color: 'rgba(255,255,255,0.4)',
              }}>
                {era.name}
              </span>

              {/* World pills */}
              <div style={{ display: 'flex', gap: 8, flex: 1, flexWrap: 'wrap' }}>
                {era.mundos.map((m, mi) => {
                  const isActive = era.active.includes(mi);
                  const isGold = era.gold?.includes(mi);
                  return (
                    <span key={mi} style={{
                      fontSize: 13, padding: '7px 12px', borderRadius: 999,
                      border: `1px solid ${isActive ? C.turquesa : isGold ? C.mango : C.border}`,
                      color: isActive ? '#06201D' : isGold ? C.mango : 'rgba(255,255,255,0.55)',
                      background: isActive ? C.turquesa : 'rgba(10,10,10,0.6)',
                      fontWeight: isActive ? 700 : 400,
                    }}>
                      {m}
                    </span>
                  );
                })}
              </div>

              {/* Badge name */}
              <span style={{ fontSize: 12, fontWeight: 700, color: C.mango }}>{era.badge}</span>
            </div>
          ))}

          {/* Prize callout */}
          <div style={{
            marginTop: 14, display: 'flex', gap: 10, alignItems: 'center',
            padding: '14px 16px', borderRadius: 12,
            background: 'rgba(253,190,2,0.08)', border: `1px solid ${C.mango}`,
            fontSize: 14, color: '#fff',
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={C.mango} strokeWidth="2">
              <polygon points="12,2 15,9 22,9 16.5,13.5 18.5,21 12,16.5 5.5,21 7.5,13.5 2,9 9,9" />
            </svg>
            <span>
              <strong>El premio:</strong> al llegar al Mundo 07, tu carta se habilita para
              recibir donaciones en el crowdfunding de T&D.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
